require('./cardsCancelPayLaterSuccess.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

//@utilities
const currencyHelper = require('utilities/currencyHelper');

class CardsCancelPayLaterSuccess extends React.Component {

    render() {
        const { cardId, immCard, immCardCancelPayLaterInfo } = this.props;
        const cancelPayLaterData = immCardCancelPayLaterInfo.get('payLaterData');
        const currency = cancelPayLaterData.get('currency');
        const currencySymbol = currencyHelper.formatCurrency(currency);
        const totalAmountToBePaid = cancelPayLaterData.getIn(['movements', '0', 'impopera']);
        const totalAmountToBePaidFormatted = `${currencyHelper.formatAmount(totalAmountToBePaid)} ${currencySymbol}`;
        const successTitle = (<FormattedText value="cardCancelPayLater-cardCancelPayLater_successTitle" injectedStrings={[immCard.getIn(['alias','current'])]} />);
        const cardAlias = immCard.getIn(['alias', 'current']);
        const goBackButtonLabel = formatText('cardCancelPayLater-cardCancelPayLater_backToCardsLink', [
            cardAlias
        ]).toUpperCase();
        const mainButton = {
            label: goBackButtonLabel,
            url: `/myprofile/cards/${cardId}/movements`
        };

        return (
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="cards-cancel-pay-later-success col-xs-offset-2 col-xs-8">
                            <WizardSuccess
                                customClassName="cards-cancel-pay-later-success"
                                successMessage={successTitle}
                                mainButton={mainButton}
                            >
                                <section className="cards-cancel-pay-later-success__content row">
                                    <div className="col-xs-4 col-md-6">
                                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                                    </div>
                                    <div className="col-xs-8 col-md-6 cards-cancel-pay-later-success__detail-container">
                                        <FormattedText value="cardCancelPayLater-cardCancelPayLater_successMessage" injectedStrings={[totalAmountToBePaidFormatted]} />
                                    </div>
                                </section>
                            </WizardSuccess>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardsCancelPayLaterSuccess.propTypes = {
    cardId: PropTypes.string.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardCancelPayLaterInfo: PropTypes.object.isRequired
};

module.exports = CardsCancelPayLaterSuccess;